// Libraries
import styled from 'styled-components'
import { motion } from 'framer-motion'

const Progress = styled(motion.img)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-top: 35px ;
  width: 165px;
  height: 165px;
`;

export default Progress;
